import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from './api/config';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  axios.defaults.withCredentials = true;

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${API_URL}/forgot-password-api`, { email })
      .then((res) => {
        if (res.data.Status === 'Success') {
          toast.success('Password reset link sent!', { position: 'top-right', autoClose: 3000 });
          navigate(res.data.redirect);
        } else if (res.data.Status === 'Duplicate') {
          toast.info(res.data.Message, { position: 'top-right', autoClose: 3000 });
        } else {
          toast.error(res.data.Message, { position: 'top-right', autoClose: 3000 });
        }
      })
      .catch(() => {
        toast.error('An error occurred. Please try again.', { position: 'top-right', autoClose: 3000 });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
        fontFamily: "'DM Sans', sans-serif",
        padding: '1rem',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ToastContainer />
      <div style={{ width: '100%', maxWidth: '520px', margin: 'auto' }}>
        <div
          style={{
            background: '#ffffff',
            borderRadius: '24px',
            overflow: 'hidden',
            boxShadow: '0 20px 40px -12px rgba(0,0,0,0.25)',
            animation: 'fadeInUp 0.5s ease-out',
          }}
        >
          {/* ── Header ── */}
          <div
            style={{
              background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
              padding: '1.5rem 1.5rem 1rem',
              textAlign: 'center',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
              <div
                style={{
                  width: '60px',
                  height: '60px',
                  background: 'rgba(255,255,255,0.15)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: 'float 3s ease-in-out infinite',
                }}
              >
                <i className="fas fa-lock" style={{ fontSize: '28px', color: 'white' }}></i>
              </div>
            </div>
            <h3
              style={{ color: 'white', margin: '0.5rem 0 0.25rem', fontSize: '1.3rem', fontWeight: '600' }}
            >
              Forgot Password?
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.75rem', marginBottom: 0 }}>
              No worries — we'll send a reset link to your email
            </p>
          </div>

          {/* ── Body ── */}
          <div style={{ padding: '1.5rem 1.25rem 1.25rem' }}>
            <form onSubmit={handleForgotPassword}>

              {/* Info banner */}
              <div
                style={{
                  background: '#f0faf3',
                  borderLeft: '3px solid #0d6e28',
                  borderRadius: '8px',
                  padding: '0.75rem',
                  marginBottom: '1.25rem',
                }}
              >
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <span style={{ fontSize: '1rem' }}>💡</span>
                  <p style={{ margin: 0, color: '#1a4a2a', fontSize: '0.78rem', fontWeight: '500' }}>
                    Enter the email address linked to your account and we'll send you a reset link.
                  </p>
                </div>
              </div>

              {/* Email field */}
              <div style={{ marginBottom: '1.25rem' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    color: '#444',
                    marginBottom: '0.35rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                  }}
                >
                  Email Address
                </label>
                <div
                  style={{
                    display: 'flex',
                    border: '1px solid #ced4da',
                    borderRadius: '40px',
                    overflow: 'hidden',
                    background: '#fff',
                    transition: 'box-shadow 0.2s, border-color 0.2s',
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(13,110,40,0.15)';
                    e.currentTarget.style.borderColor = '#0d6e28';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.boxShadow = '';
                    e.currentTarget.style.borderColor = '#ced4da';
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '0 0.75rem 0 1rem',
                      color: '#aaa',
                    }}
                  >
                    <i className="fas fa-envelope" style={{ fontSize: '16px' }}></i>
                  </span>
                  <input
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      flex: 1,
                      border: 'none',
                      outline: 'none',
                      padding: '0.65rem 1rem 0.65rem 0',
                      fontSize: '0.85rem',
                      background: 'transparent',
                      color: '#333',
                    }}
                  />
                </div>
              </div>

              {/* Send Reset Link button */}
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  background: loading ? '#c0cfc5' : '#0d6e28',
                  border: 'none',
                  borderRadius: '40px',
                  padding: '0.7rem',
                  fontWeight: '600',
                  fontSize: '0.85rem',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  color: '#ffffff',
                  marginBottom: '0.75rem',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => { if (!loading) e.target.style.background = '#0a5520'; }}
                onMouseLeave={(e) => { if (!loading) e.target.style.background = '#0d6e28'; }}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      style={{ width: '0.8rem', height: '0.8rem' }}
                    ></span>
                    Sending...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane me-2"></i>
                    Send Reset Link
                  </>
                )}
              </button>

              {/* Back to Login */}
              <button
                type="button"
                onClick={() => navigate('/login')}
                style={{
                  width: '100%',
                  padding: '0.7rem',
                  backgroundColor: 'transparent',
                  color: '#0d6e28',
                  border: '1.5px solid #0d6e28',
                  borderRadius: '40px',
                  fontSize: '0.85rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  marginBottom: '0.75rem',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#0d6e28';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#0d6e28';
                }}
              >
                <i className="fas fa-arrow-left me-2"></i>
                Back to Login
              </button>

              {/* Already have account note */}
              <div
                style={{ background: '#f8fcf9', borderRadius: '8px', padding: '0.5rem', textAlign: 'center' }}
              >
                <p style={{ fontSize: '0.65rem', color: '#999', margin: 0 }}>
                  <i className="fas fa-user" style={{ marginRight: '5px' }}></i>
                  Remember your password?{' '}
                  <Link to="/login" style={{ color: '#0d6e28', textDecoration: 'none', fontWeight: '600' }}>
                    Login here
                  </Link>
                </p>
              </div>

            </form>
          </div>

          {/* ── Footer ── */}
          <div
            style={{
              borderTop: '1px solid #e5ede8',
              padding: '0.6rem',
              background: '#fafdfb',
              textAlign: 'center',
            }}
          >
            <p style={{ fontSize: '0.6rem', color: '#8aa899', margin: 0 }}>
              <i className="fas fa-headset me-1"></i>
              Need help? Contact support@oret.africa
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50%       { transform: translateY(-5px); }
        }
      `}</style>
    </div>
  );
}

export default ForgotPassword;